import { PrimitiveValueType, RowDataReducerAction } from "../../../../../types";

//mainting it here since there is no API for this
const UOM_CODES_LIST: { [key: string]: string }[] = [
  { uom_cd: "CS", uom_desc: "Case" },
  { uom_cd: "QT", uom_desc: "Quart" },
  { uom_cd: "BBL", uom_desc: "Barrel" },
  { uom_cd: "4PK", uom_desc: "Pack of 4" },
  { uom_cd: "LT", uom_desc: "Liters" },
  { uom_cd: "FT", uom_desc: "Foot" },
  { uom_cd: "GAL", uom_desc: "Gallon" },
  { uom_cd: "EA", uom_desc: "Each" },
  { uom_cd: "OZ", uom_desc: "Ounce" },
  { uom_cd: "LB", uom_desc: "Pound" },
  { uom_cd: "PT", uom_desc: "Pint" },
  { uom_cd: "IN", uom_desc: "Inch" },
  { uom_cd: "6PK", uom_desc: "Pack of 6" },
  { uom_cd: "G", uom_desc: "Gram" },
  { uom_cd: "CM", uom_desc: "Centimeter" },
  { uom_cd: "KG", uom_desc: "Kilogram" },
  { uom_cd: "RM", uom_desc: "Ream" },
  { uom_cd: "M", uom_desc: "Meter" },
  { uom_cd: "DZ", uom_desc: "Dozen" },
  { uom_cd: "YD", uom_desc: "Yard" },
];

const TARGET_CODE_FIELD = "uom_cd";

export const updateUnitsOfMeasureCode = (
  propertyKey: string,
  inputValue: PrimitiveValueType | undefined,
  dispatch: React.Dispatch<RowDataReducerAction>,
): void => {
  const targetFieldValue =
    UOM_CODES_LIST.find((code) => code[propertyKey] === inputValue)?.[
      TARGET_CODE_FIELD
    ] ?? null;
  dispatch({
    type: "UPDATE_FIELD",
    payload: {
      propertyKey: TARGET_CODE_FIELD,
      newFieldValue: targetFieldValue,
    },
  });
};
